"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = exports.default = exports.Label = exports.ErrorMessage = void 0;
var _base = _interopRequireDefault(require("@emotion/styled/base"));
var _react = require("@emotion/react");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
const Label = exports.Label = /*#__PURE__*/(0, _base.default)("span", process.env.NODE_ENV === "production" ? {
  target: "edalgqg1"
} : {
  target: "edalgqg1",
  label: "Label"
})(process.env.NODE_ENV === "production" ? {
  name: "1ge8ozm",
  styles: "line-height:22px;font-size:1em;font-weight:600;margin-bottom:4px"
} : {
  name: "1ge8ozm",
  styles: "line-height:22px;font-size:1em;font-weight:600;margin-bottom:4px",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});
const ErrorMessage = exports.ErrorMessage = /*#__PURE__*/(0, _base.default)("span", process.env.NODE_ENV === "production" ? {
  target: "edalgqg0"
} : {
  target: "edalgqg0",
  label: "ErrorMessage"
})("font-size:14px;padding-left:25px;line-height:30px;font-weight:600;margin-bottom:0;color:", props => props.theme.alert, ";");
const styles = exports.styles = {
  default: (theme, height, width) => /*#__PURE__*/(0, _react.css)("position:relative;display:grid;grid-template-rows:min-content;&:focus-within span{color:", theme.primary, ";}input{height:", height, ";width:", width, ";font-size:16px;line-height:20px;outline:none;border-color:", theme.border, ";border-width:1px;border-radius:5px;border-style:solid;padding:0 10px;&:focus{border-color:", theme.primary, ";}&:disabled{background-color:", theme.disabled, ";}&::-webkit-outer-spin-button,&::-webkit-inner-spin-button{-webkit-appearance:none;margin:0;}&[type='number']{-moz-appearance:textfield;}}" + (process.env.NODE_ENV === "production" ? "" : ";label:default;")),
  disabled: theme => /*#__PURE__*/(0, _react.css)({
    cursor: 'not-allowed',
    backgroundColor: theme.disabled,
    borderColor: theme.disabled
  }, process.env.NODE_ENV === "production" ? "" : ";label:disabled;"),
  nullable: process.env.NODE_ENV === "production" ? {
    name: "1azakc",
    styles: "text-align:center"
  } : {
    name: "1lryr3e-nullable",
    styles: "text-align:center;label:nullable;",
    toString: _EMOTION_STRINGIFIED_CSS_ERROR__
  },
  validation: process.env.NODE_ENV === "production" ? {
    name: "dbzhw2",
    styles: "&>svg{position:absolute;bottom:7px;left:3px;}"
  } : {
    name: "1c4etbp-validation",
    styles: "&>svg{position:absolute;bottom:7px;left:3px;};label:validation;",
    toString: _EMOTION_STRINGIFIED_CSS_ERROR__
  },
  invalid: theme => /*#__PURE__*/(0, _react.css)("&:focus-within span{color:black;}input{border-color:", theme.alert, ";&:active,&:focus,&:hover{border-color:", theme.alert, ";}}svg{path{fill:", theme.alert, ";}}" + (process.env.NODE_ENV === "production" ? "" : ";label:invalid;"))
};
var _default = exports.default = styles;